import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { ApiUrl } from './apiUrl';

@Injectable({
  providedIn: 'root'
})
export class DeveloperClientsService {

  constructor(private api: ApiService) {}

  getScopes() {
    return this.api.getRequest(ApiUrl.OAUTH_SCOPES);
  }

  getClients() {
    return this.api.getRequest(ApiUrl.OAUTH_CLIENTS);
  }

  getClient(clientId: string) {
    return this.api.getRequest(ApiUrl.OAUTH_CLIENT_BY_ID(clientId));
  }

  createClient(data: {
    name: string;
    description?: string;
    storeIds: string[];
    chainId?: string | null;
    scopes: string[];
  }) {
    return this.api.postRequest(ApiUrl.OAUTH_CLIENTS, data);
  }

  updateClient(
    clientId: string,
    data: {
      name?: string;
      description?: string;
      storeIds?: string[];
      chainId?: string | null;
      scopes?: string[];
    }
  ) {
    return this.api.putRequest(ApiUrl.OAUTH_CLIENT_BY_ID(clientId), data);
  }

  rotateSecret(clientId: string) {
    return this.api.putRequest(ApiUrl.OAUTH_ROTATE_SECRET(clientId), {});
  }

  revokeClient(clientId: string) {
    return this.api.putRequest(ApiUrl.OAUTH_REVOKE(clientId), {});
  }

  activateClient(clientId: string) {
    return this.api.putRequest(ApiUrl.OAUTH_ACTIVATE(clientId), {});
  }
}
